import { useRef, useEffect } from "react";

//
/**
 * Hook to provide the previous props.
 *
 * @example
 *
 * const { count, name } = props;
 * const prevAmount = usePrevious({ count, name });
 * useEffect(
 *  () => {
 *    if (prevAmount.count !== count) {
 *      // process here
 *    }
 *    if (prevAmount.name !== name) {
 *      // process here
 *    }
 *  },
 * [count, name, prevAmount]
 *
 */
export default function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/hooks/usePrevious.js